export const conversation = {
  state: {},
  reducers: {
    update(state, { id, lastModified, organizationId }) {
      return Object.assign({}, state, {
        id,
        lastModified,
        organizationId,
      });
    },
  },
  effects: {
    setConversation(conversation, rootState) {
      this.update(conversation);
    },
    updateConversation(conversation, rootState) {
      if (conversation.id === rootState.conversation.id) {
        this.update(conversation);
      }
    },
  },
};
